import React, { ChangeEvent, RefObject } from 'react';
import { Button, Grid, Header, Image, Label, Segment, SemanticWIDTHS } from 'semantic-ui-react';
import { strings } from '../..';
import { Allegato } from '../models';

export interface FileSelectorProps {
    images: Allegato[],
    imagesPerGroup?: number,
    onImageAdded: (image: Allegato) => void,
    onImageRemoved: (image: Allegato) => void,
}

export default class FileSelector extends React.Component<FileSelectorProps> {
    private inputRef: RefObject<HTMLInputElement>;
    private itemPerGroup: number;

    constructor(props: FileSelectorProps) {
        super(props);

        this.itemPerGroup = this.props.imagesPerGroup || 4;
        this.inputRef = React.createRef<HTMLInputElement>();
    }

    render() {
        const immaginiRaggruppate: Array<Array<Allegato>> = []
        for (var i = 0; i < this.props.images.length; i += this.itemPerGroup) {
            const gruppo = this.props.images.slice(i, i + this.itemPerGroup);
            immaginiRaggruppate.push(gruppo);
        }

        const hasAllegati: boolean = immaginiRaggruppate.length > 0;

        return (
            <>
                <Segment attached='top' clearing>                    
                    <Header floated='left' as='h3' icon='images outline' content={strings.archivi.fileSelector.titolo} />
                    <Button floated='right' icon='add' circular color='green' onClick={this.referenceClick} />
                    <input 
                        type='file' 
                        accept=".jpg,.jpeg,.png,.bmp" 
                        ref={this.inputRef}
                        onChange={this.onInputChange} 
                        style={{ display: 'none' }} 
                    />
                    <Label>{strings.archivi.fileSelector.imageOnly}</Label>
                </Segment>
                <Segment attached>
                    <Grid celled={hasAllegati} stackable>
                        {hasAllegati && immaginiRaggruppate.map((gruppo, index) => this.renderImages(gruppo, index))}
                        {!hasAllegati && this.renderNoAllegati()}
                    </Grid>
                </Segment>
            </>
        )
    }

    renderImages = (gruppo: Allegato[], index: number) => {
        const columnsCount = this.itemPerGroup as SemanticWIDTHS;
        return (
            <Grid.Row key={index} columns={columnsCount}>
                {gruppo.map(this.renderImage)}
            </Grid.Row>
        );
    }

    renderImage = (image: Allegato) => (
        <Grid.Column key={image.file.name}>
            <Label corner='right' icon='close' color='red' onClick={() => this.props.onImageRemoved(image)} />
            <Image size='small' src={image.thumbnail} />
        </Grid.Column>
    )

    renderNoAllegati = () => (
        <Grid.Row>
            <Grid.Column textAlign='center' verticalAlign='middle'>
                <Header as='h2'>
                    <Header.Content>
                        {strings.archivi.fileSelector.noImageTitolo}
                        <Header.Subheader>{strings.archivi.fileSelector.noImageDescrizione}</Header.Subheader>
                    </Header.Content>
                </Header>
            </Grid.Column>
        </Grid.Row>
    )

    onInputChange = (event: ChangeEvent<HTMLInputElement>) => {
        if (event.target.files === null) return;

        const file = event.target.files[0];
        var fileReader = new FileReader();
        if (file.type.match('image')) {
            fileReader.onload = () => {
                const allegato: Allegato = {
                    thumbnail: String(fileReader.result),
                    file: file,
                }

                this.props.onImageAdded(allegato);
            };
            fileReader.readAsDataURL(file);
        }
    }

    referenceClick = () => {
        if (this.inputRef.current !== null) {
            this.inputRef.current.click();
        }
    }
}